"use strict";

import {onFind} from "@elements/init-modules-in-scope";
import BlazeSlider from 'blaze-slider';
import {removeClass,on,addClass, findAllIn, findIn} from '@elements/dom-utils';

const selectors = {
    base: '.js-facilities-slider',
    items: '.js-facilities-slider__item'
};

export function init() {
    onFind(selectors.base, function (baseElement) {
        let onSlide = false;
        let blazeItems = findAllIn(selectors.items, baseElement);
        const blazeSlider = new BlazeSlider(baseElement, {
            all: {
                slidesToScroll: 1,
                slidesToShow: 3,
                slideGap: 'calc(33rem/16)',
                draggable: true,
                transitionDuration: 250,
                transitionTimingFunction: 'cubic-bezier(0.6, 0, 0.5, 1)',
                loop: false
            },
            '(max-width: 768px)': {
                slidesToScroll: 1,
                slidesToShow: 1,
            }
        });

        const prevBtn = findIn('.blaze-prev', baseElement);
        const nextBtn = findIn('.blaze-next', baseElement);

        const updateButtons = (pageIndex) => {
            const totalPages = blazeSlider.states.length;
            if (prevBtn) {
                if (pageIndex === 0) {
                    prevBtn.setAttribute('disabled', 'disabled');
                    prevBtn.setAttribute('aria-disabled', 'true');
                } else {
                    prevBtn.removeAttribute('disabled');
                    prevBtn.setAttribute('aria-disabled', 'false');
                }
            }

            if (nextBtn) {
                if (pageIndex === totalPages - 1) {
                    nextBtn.setAttribute('disabled', 'disabled');
                    nextBtn.setAttribute('aria-disabled', 'true');
                } else {
                    nextBtn.removeAttribute('disabled');
                    nextBtn.setAttribute('aria-disabled', 'false');
                }
            }
        };

        // Initialize button states
        updateButtons(0);

        blazeSlider.onSlide((pageIndex) => {
            updateButtons(pageIndex);
        });
    });
}

